import React, { useContext, useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { Space, Table, Tag, Button } from 'antd';

import { numberFormatter } from '../../../components/formatters/numberFormatter';




const LoadTransferJv = (props) => {

    const { setTransactions, journalVoucher, cart, totalCost, selectedCurrency } = props;

    const { api, userData, settingData, rateMainToSecondaryCurrency, rateToMainCurrency, warehouseData } = useContext(DataContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role;



    // load Transactions
    useEffect(() => {
        loadJV();
    }, [journalVoucher, cart]);

    const accountId = journalVoucher?.accountId;
    const warehouseId = journalVoucher?.warehouseId;
    const transferWarehouseId = journalVoucher?.transferWarehouseId;
    const cashAccountId = userRole.cashAccountId;
    const isDebit = journalVoucher.isDebit;

    const stockTransferAccountId = settingData.stockTransferAccountId;

    const downPayment = journalVoucher.downPayment;

    const rate = selectedCurrency?.rate;
    const currencyId = selectedCurrency?.id;

    const fromWarehouse = warehouseData.find(warehouse => warehouse.id == warehouseId)?.name;
    const toWarehouse = warehouseData.find(warehouse => warehouse.id == transferWarehouseId)?.name;


    const loadJV = () => {

        let updatedTransactions = [];


        updatedTransactions = loadAcountTransaction(updatedTransactions, !isDebit, stockTransferAccountId, 'Stock', totalCost, warehouseId);
        updatedTransactions = loadAcountTransaction(updatedTransactions, isDebit, stockTransferAccountId, 'Stock', totalCost, transferWarehouseId);

        console.log(stockTransferAccountId)

        setTransactions(updatedTransactions)

    }


    const loadAcountTransaction = (updatedTransactions, isDebit, accountId, type, total, warehouseId) => {


        const debit = isDebit ? total : 0;
        const credit = !isDebit ? total : 0;

        const totalDebit = rateToMainCurrency(selectedCurrency, debit);
        const totalCredit = rateToMainCurrency(selectedCurrency, credit);

        const secondaryTotalDebit = rateMainToSecondaryCurrency(totalDebit);
        const secondaryTotalCredit = rateMainToSecondaryCurrency(totalCredit);

        const accountTransaction = {
            type: type,
            accountId: accountId,
            details: '',
            isDebit: isDebit,
            debit: debit,
            credit: credit,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
            secondaryTotalDebit: secondaryTotalDebit,
            secondaryTotalCredit: secondaryTotalCredit,
            currencyId: currencyId,
            rate: rate,
            haveCart: true,
            warehouseId: warehouseId,
        }

        updatedTransactions.push(accountTransaction);

        return updatedTransactions;
    }


    return (<></>)
}


export default LoadTransferJv;